import React from 'react';
import ReactTooltip from 'react-tooltip';

const TooltipConfig = {
  type: "dark",
  place: "bottom",
  className: "tooltip",
  event: "click",
  globalEventOff: "click",
};

const Tooltipps = () => (
    <div className="tooltips">
        <ReactTooltip id="receipt-date" {...TooltipConfig}>
            <p><strong>Zugang der Kündigung, was heißt Zugang?</strong></p>
            <p>
                Die Kündigung gilt als zugegangen, wenn sie derart in den Machtbereich 
                (Sphäre) des Gekündigten gelangt ist, dass mit der Kenntnisnahme unter 
                regelmäßigen Umständen zu rechnen ist. Dies ist in der Regel der Fall, 
                wenn der Arbeitgeber die Kündigung dem Gekündigten überreicht oder sie 
                im Briefkasten eingeworfen wird.
            </p>
        </ReactTooltip>

        <ReactTooltip id="is-written-notice" {...TooltipConfig}>
            <p><strong>Was bedeutet eine „schriftliche“ Kündigung?</strong></p>
            <p>
                Die Kündigung des Arbeitsverhältnisses muss zwingend schriftlich erfolgen. 
                Ist das nicht der Fall, so entfaltet die Kündigung von Anfang an keine Rechtswirkung. 
                Das Kündigungsschreiben muss dem Gekündigten im Original und eigenhändig vom 
                Kündigungsberechtigten unterschrieben zugehen. Eine Kündigung per Telefax, Computerfax, 
                Email oder auf mündlichem Weg ist daher unzulässig.
            </p>
            <p><strong>War der Kündigende zum Ausspruch der Kündigung berechtigt?</strong></p>
            <p>
                Neben dem Arbeitnehmer ist auf der Arbeitgeberseite der persönlich handelnde Arbeitgeber 
                selbst oder sein gesetzlicher bzw. rechtsgeschäftlicher Vertreter kündigungsberechtigt. 
                Hat diese Person das Kündigungsschreiben nicht unterzeichnet, ist die Kündigung unwirksam.
            </p>
        </ReactTooltip>

        <ReactTooltip id="kind-of-notice" {...TooltipConfig}>
            <p><strong>Was heißt außerordentliche Kündigung? Ist die Kündigungsfrist beachtet?</strong></p>
            <p>
                Eine außerordentliche Kündigung ist eine Kündigung, durch die das Vertragsverhältnis 
                aus wichtigem Grund in der Regel ohne Einhalten einer gesetzlichen, tarifvertraglichen 
                oder einzelvertraglichen Kündigungsfrist beendet wird. Sie kann nur in­ner­halb von zwei 
                Wo­chen aus­ge­spro­chen wer­den, nach­dem der zur Kündi­gung Be­rech­tig­te den wich­ti­gen Grund 
                er­fah­ren hat.
            </p>
        </ReactTooltip>

        <ReactTooltip id="start-date" {...TooltipConfig}>
            <p><strong>Seit wann besteht das Arbeitsverhältnis?</strong></p>
            <p>
                Wesentlich für die Anwendung des Kündigungsschutzgesetzes ist der 
                Beginn des Beschäftigungsverhältnisses. Hierbei handelt es sich um 
                den Zeitpunkt, an dem der Arbeitnehmer mit seiner neuen Tätigkeit beginnt. 
                In der Regel fallen das Datum des Vertragsabschlusses und der Beginn des 
                Beschäftigungsverhältnisses nicht zusammen. Der Beginn ist grds. im Arbeitsvertrag 
                geregelt.
            </p>
        </ReactTooltip>

        <ReactTooltip id="has-more-than-ten" {...TooltipConfig}>
            <p><strong>Beschäftigtenzahl, Teilzeitmitarbeiter, Auszubildende, gemeinsamer Betrieb.</strong></p>
            <p>
                Maßgeblich ist die Anzahl der Vollzeitbeschäftigte, die in Ihrem Unternehmen tätig ist. 
                Hierbei sind teilzeitbeschäftigte Arbeitnehmer mit einer regelmäßigen wöchentlichen Arbeitszeit 
                von nicht mehr als 20 Stunden mit 0,5 und nicht mehr als 30 Stunden mit 0,75 zu berücksichtigen. 
                Hiervon erfasst sind auch Leiharbeiter. Bei einem Gemeinschaftsbetrieb zählen für die Anwendbarkeit 
                des Kündigungsschutzgesetzes alle den Betrieben angehörige Beschäftigte.
            </p>
            <p>
                Ein Gemeinschaftsbetrieb ist ein gemeinsamer Betrieb mehrerer rechtlich selbständiger Unternehmen 
                (vgl. § 1 Abs. 1 Satz 2 BetrVG). In einem Gemeinschaftsbetrieb gibt es also mindestens zwei verschiedene 
                Unternehmen, die formal betrachtet Arbeitgeber sein können. Die in einem Gemeinschaftsbetrieb beschäftigten 
                Arbeitnehmer haben einen Arbeitsvertrag aber in der Regel nur mit einem der an dem Gemeinschaftsbetrieb 
                beteiligten Unternehmen.
            </p>
        </ReactTooltip>

        <ReactTooltip id="has-special-protection" {...TooltipConfig}>
            <p><strong>Besteht Sonderkündigungsschutz?</strong></p>
            <p>
                Unter anderem für folgende Personengruppen besteht ein besonderer Kündigungsschutz: 
                Menschen mit einer Schwerbehinderung (mindestens 50% oder dessen gleichgestellt), 
                Betriebsratsmitglied, Azubi, Elternzeit, Mutterschutz, Personen in Pflegezeit.
            </p>
        </ReactTooltip>
    </div>
);

export default Tooltipps;


// WEBPACK FOOTER //
// ./src/components/tooltips.js